import { getRgVersions } from '../../utils/internal/get-versions.js';

function aggPropsToDto({ raw, versions = getRgVersions() }) {
    const dto = {
        zones: raw.zones,
        face2FaceSeparation: raw.face2FaceSeparation,
        face2SideSeparation: raw.face2SideSeparation,
        optimisePlots: raw.optimisePlots,
        dataset: raw.dataset.id,
        versions,
        dto: true
    };
    return dto;
}

export { aggPropsToDto };
//# sourceMappingURL=agg-props-to-dto.js.map
